import { render, staticRenderFns } from "./fillSendBack.vue?vue&type=template&id=2d68dcea&scoped=true"
import script from "./fillSendBack.vue?vue&type=script&lang=ts"
export * from "./fillSendBack.vue?vue&type=script&lang=ts"
import style0 from "./fillSendBack.vue?vue&type=style&index=0&id=2d68dcea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68dcea",
  null
  
)

export default component.exports